'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi3Bar = function DeviceSignalWifi3Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
  );
};
DeviceSignalWifi3Bar = (0, _pure2.default)(DeviceSignalWifi3Bar);
DeviceSignalWifi3Bar.displayName = 'DeviceSignalWifi3Bar';
DeviceSignalWifi3Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi3Bar;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/device/signal-wifi-3-bar.js
// module id = 2916
// module chunks = 0